module.exports = __webpack_public_path__ + "img/16_63.50dab140.png";